module.exports = __webpack_public_path__ + "01ad3c5397727aa49845bdcf8d44620f.MP3";